export enum GuideType {
    FullyGuided = 1,
    PilotGuided = 2,
}
